export var ButtonBackgroundType;
(function (ButtonBackgroundType) {
    ButtonBackgroundType["Filled"] = "filled";
    ButtonBackgroundType["Outlined"] = "outlined";
    ButtonBackgroundType["Text"] = "text";
})(ButtonBackgroundType || (ButtonBackgroundType = {}));
export var IconPlacement;
(function (IconPlacement) {
    IconPlacement["LEFT"] = "left";
    IconPlacement["RIGHT"] = "right";
})(IconPlacement || (IconPlacement = {}));
//# sourceMappingURL=Constants.js.map